import {Company} from "../entities/company";
import {
    Button,
    Card,
    CardActions,
    CardContent,
    CardHeader,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControlLabel,
    IconButton,
    TextField,
    Typography
} from "@mui/material";
import {ArrowBack, Edit} from "@mui/icons-material";
import {useState} from "react";
import {DateTime} from "luxon";
import {DatePicker} from "@mui/x-date-pickers";
import {CompanyUpdateDTO} from "../entities/companyUpdateDTO";
import {enqueueSnackbar} from "notistack";

export interface CompanyCardProps {
    company: Company;
    showAdminDetails: boolean;
    onBackClick: () => void;
    onEdit?: (company: CompanyUpdateDTO) => void;
}

export const CompanyCard = ({
                                company, onBackClick, showAdminDetails, onEdit = () => {
    }
                            }: CompanyCardProps) => {

    const [isEditOpen, setEditOpen] = useState(false);
    const [tokenManagerEmail, setTokenManagerEmail] = useState<string>(company.tokenManagerEmail);
    const [tokenManagerEmailChanged, setTokenManagerEmailChanged] = useState<boolean>(false);
    const [membershipCanceledChanged, setMembershipCanceledChanged] = useState<boolean>(false);
    const [membershipCanceled, setMembershipCanceled] = useState<boolean>(company.membershipCanceled);
    const [membershipCanceledAtChanged, setMembershipCanceledAtChanged] = useState<boolean>(false);
    const [membershipCanceledAt, setMembershipCanceledAt] = useState<DateTime>(DateTime.fromISO(company.membershipCanceledAt));
    const [renewalDateChanged, setRenewalDateChanged] = useState<boolean>(false);
    const [renewalDate, setRenewalDate] = useState<DateTime>(DateTime.fromISO(company.renewalDate));
    const [tokenResellerChanged, setTokenResellerChanged] = useState<boolean>(false);
    const [tokenReseller, setTokenReseller] = useState<boolean>(company.tokenReseller);

    const getSubHeader = (company: Company) => {
        if (company.membershipCanceled) {
            return <>
                Membership canceled
                {!!company.membershipCanceledAt && ` since ${DateTime.fromISO(company.membershipCanceledAt).toLocaleString()}`}
            </>
        }
        return <>Member{company.renewalDate && ` until ${DateTime.fromISO(company.renewalDate).toLocaleString()}`}</>
    }

    const saveChanges = () => {
        if (!tokenManagerEmailChanged && !membershipCanceledAtChanged && !membershipCanceledChanged && !renewalDateChanged && !tokenResellerChanged) {
            setEditOpen(false)
            enqueueSnackbar("Nothing to change", {variant: "info"})
            return
        }
        const changes: CompanyUpdateDTO = {}
        if (tokenManagerEmailChanged) {
            changes.tokenManagerEmail = tokenManagerEmail
        }
        if (membershipCanceledChanged) {
            changes.membershipCanceled = membershipCanceled
        }
        if (membershipCanceledAtChanged) {
            changes.membershipCanceledAt = membershipCanceledAt?.toJSDate()
        }
        if (renewalDateChanged) {
            changes.renewalDate = renewalDate?.toJSDate()
        }
        if (tokenResellerChanged) {
            changes.tokenReseller = tokenReseller
        }
        onEdit(changes)
        setEditOpen(false)


    }

    const updateTokenManagerEmail = (ev: any) => {
        setTokenManagerEmail(ev.target.value)
        setTokenManagerEmailChanged(true)
    }

    const updateMembershipCanceled = (ev: any) => {
        setMembershipCanceled(ev.target.checked)
        setMembershipCanceledChanged(true)
    }

    const updateMembershipCanceledAt = (ev: any) => {
        setMembershipCanceledAt(ev)
        setMembershipCanceledAtChanged(true)
    }

    const updateRenewalDate = (ev: any) => {
        setRenewalDate(ev)
        setRenewalDateChanged(true)
    }

    const updateTokenReseller = (ev: any) => {
        setTokenReseller(ev.target.checked)
        setTokenResellerChanged(true)
    }

    return <Card>
        <IconButton onClick={onBackClick}
                    size="small"><ArrowBack/>Back</IconButton>
        <CardHeader title={company.name} subheader={getSubHeader(company)}/>
        {showAdminDetails ? <CardContent>
            <Typography variant="caption" color="primary">
                Created at {DateTime.fromISO(company.createdAt).toLocaleString({
                dateStyle: "short",
                timeStyle: "short"
            })}
            </Typography><Typography variant="caption"> by {company.createdBy}</Typography>
            <Typography variant="caption" component="p">
                Last update
                on {DateTime.fromISO(company.lastModifiedAt).toLocaleString({
                dateStyle: "short",
                timeStyle: "short"
            })} by {company.lastModifiedBy}
            </Typography>
            <Typography>
                Token manager: {company.tokenManagerEmail}
            </Typography>
            <Typography>
                Is a Token Reseller: {company.tokenReseller ? 'Yes' : 'No'}
            </Typography>
        </CardContent> : <></>}
        {showAdminDetails ? <CardActions>
            <Button onClick={() => {
                setEditOpen(true)
            }} variant="outlined"><Edit/>Edit</Button>
        </CardActions> : <></>}
        {isEditOpen && <Dialog open={isEditOpen} onClose={() => setEditOpen(false)}>
            <DialogTitle>Edit {company.name}</DialogTitle>
            <DialogContent>
                <TextField value={tokenManagerEmail} placeholder="Token manager email" type="email"
                           name="tokenManagerEmail"
                           label="Token manager email" fullWidth sx={{marginTop: "1rem"}}
                           onChange={updateTokenManagerEmail}/>
                <FormControlLabel control={<Checkbox onChange={updateMembershipCanceled} checked={membershipCanceled}/>}
                                  label="Is company's membership canceled?"/>

                <FormControlLabel control={<Checkbox onChange={updateTokenReseller} checked={tokenReseller}/>}
                                  label="Is the company a token reseller ?"/>

                {membershipCanceled && <DatePicker label="End of membership" sx={{marginTop: "1rem", "width": "100%"}}
                                                   value={membershipCanceledAt}
                                                   onChange={updateMembershipCanceledAt}/>}
                {!membershipCanceled &&
                    <DatePicker label="Company renewal date" sx={{marginTop: "1rem", "width": "100%"}}
                                value={renewalDate}
                                onChange={updateRenewalDate}/>}
            </DialogContent>
            <DialogActions>
                <Button variant="text" color="error" onClick={() => setEditOpen(false)}>Cancel</Button>
                <Button variant="contained" color="success" disabled={membershipCanceled && !membershipCanceledAt}
                        onClick={() => saveChanges()}>Save changes</Button>
            </DialogActions>
        </Dialog>}
    </Card>
}